function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40 147.875H2.66724C1.19507 147.875 0 146.684 0 145.209V107.875C0 106.4 1.19507 105.209 2.66724 105.209H40C41.4722 105.209 42.6672 106.4 42.6672 107.875V145.209C42.6672 146.684 41.4722 147.875 40 147.875ZM5.33325 142.542H37.3328V110.542H5.33325V142.542Z",
  fill: "#3F95BC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M157.333 147.875H120C118.528 147.875 117.333 146.684 117.333 145.209V107.875C117.333 106.4 118.528 105.209 120 105.209H157.333C158.805 105.209 160 106.4 160 107.875V145.209C160 146.684 158.805 147.875 157.333 147.875ZM122.667 142.542H154.667V110.542H122.667V142.542Z",
  fill: "#3F95BC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M98.667 147.875H61.333C59.8608 147.875 58.667 146.684 58.667 145.209V107.875C58.667 106.4 59.8608 105.209 61.333 105.209H98.667C100.139 105.209 101.333 106.4 101.333 107.875V145.209C101.333 146.684 100.139 147.875 98.667 147.875ZM64.0002 142.542H95.9998V110.542H64.0002V142.542Z",
  fill: "#3F95BC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 126.542C11.8611 126.542 10.666 125.349 10.666 123.874V118.541C10.666 117.066 11.8611 115.875 13.3333 115.875H18.6665C20.1387 115.875 21.3325 117.066 21.3325 118.541C21.3325 120.016 20.1387 121.208 18.6665 121.208H15.9993V123.874C15.9993 125.349 14.8054 126.542 13.3333 126.542Z",
  fill: "#3F95BC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3335 137.208H24.0002C22.5281 137.208 21.333 136.017 21.333 134.542C21.333 133.067 22.5281 131.875 24.0002 131.875H26.6663V129.208C26.6663 127.733 27.8613 126.542 29.3335 126.542C30.8057 126.542 31.9995 127.733 31.9995 129.208V134.542C31.9995 136.017 30.8057 137.208 29.3335 137.208Z",
  fill: "#3F95BC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M72 126.542C70.5291 126.542 69.334 125.349 69.334 123.874V118.541C69.334 117.066 70.5291 115.875 72 115.875H77.3333C78.8054 115.875 80.0005 117.066 80.0005 118.541C80.0005 120.016 78.8054 121.208 77.3333 121.208H74.6672V123.874C74.6672 125.349 73.4722 126.542 72 126.542Z",
  fill: "#3F95BC"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M88.0005 137.208H82.6672C81.1951 137.208 80 136.017 80 134.542C80 133.067 81.1951 131.875 82.6672 131.875H85.3333V129.208C85.3333 127.733 86.5283 126.542 88.0005 126.542C89.4714 126.542 90.6665 127.733 90.6665 129.208V134.542C90.6665 136.017 89.4714 137.208 88.0005 137.208Z",
  fill: "#3F95BC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M98.667 54.5422H61.333C59.8608 54.5422 58.667 53.3496 58.667 51.875V14.5422C58.667 13.0664 59.8608 11.875 61.333 11.875H98.667C100.139 11.875 101.333 13.0664 101.333 14.5422V51.875C101.333 53.3496 100.139 54.5422 98.667 54.5422ZM64.0002 49.2078H95.9998V17.2083H64.0002V49.2078Z",
  fill: "#3F95BC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M72 33.2075C70.5291 33.2075 69.334 32.0161 69.334 30.5415V25.2083C69.334 23.7336 70.5291 22.541 72 22.541H77.3333C78.8054 22.541 80.0005 23.7336 80.0005 25.2083C80.0005 26.6829 78.8054 27.8743 77.3333 27.8743H74.6672V30.5415C74.6672 32.0161 73.4722 33.2075 72 33.2075Z",
  fill: "#3F95BC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M88.0005 43.8745H82.6672C81.1951 43.8745 80 42.6831 80 41.2085C80 39.7339 81.1951 38.5413 82.6672 38.5413H85.3333V35.8752C85.3333 34.4006 86.5283 33.208 88.0005 33.208C89.4714 33.208 90.6665 34.4006 90.6665 35.8752V41.2085C90.6665 42.6831 89.4714 43.8745 88.0005 43.8745Z",
  fill: "#3F95BC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M130.666 126.542C129.194 126.542 128 125.349 128 123.874V118.541C128 117.066 129.194 115.875 130.666 115.875H135.999C137.471 115.875 138.667 117.066 138.667 118.541C138.667 120.016 137.471 121.208 135.999 121.208H133.333V123.874C133.333 125.349 132.138 126.542 130.666 126.542Z",
  fill: "#3F95BC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M146.666 137.208H141.333C139.861 137.208 138.667 136.017 138.667 134.542C138.667 133.067 139.861 131.875 141.333 131.875H144V129.208C144 127.733 145.194 126.542 146.666 126.542C148.138 126.542 149.333 127.733 149.333 129.208V134.542C149.333 136.017 148.138 137.208 146.666 137.208Z",
  fill: "#3F95BC"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M21.333 110.542C19.8608 110.542 18.667 109.35 18.667 107.875V89.208C18.667 87.7334 19.8608 86.542 21.333 86.542C22.8052 86.542 24.0002 87.7334 24.0002 89.208V107.875C24.0002 109.35 22.8052 110.542 21.333 110.542Z",
  fill: "#3F95BC"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M138.667 110.542C137.195 110.542 136 109.35 136 107.875V89.208C136 87.7334 137.195 86.542 138.667 86.542C140.139 86.542 141.333 87.7334 141.333 89.208V107.875C141.333 109.35 140.139 110.542 138.667 110.542Z",
  fill: "#3F95BC"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M138.667 91.8748C137.195 91.8748 136 90.6833 136 89.2075C136 84.7971 132.411 81.2083 128 81.2083H31.9995C27.5891 81.2083 24.0002 84.7971 24.0002 89.2075C24.0002 90.6833 22.8052 91.8748 21.333 91.8748C19.8608 91.8748 18.667 90.6833 18.667 89.2075C18.667 81.8564 24.6484 75.875 31.9995 75.875H128C135.352 75.875 141.333 81.8564 141.333 89.2075C141.333 90.6833 140.139 91.8748 138.667 91.8748Z",
  fill: "#3F95BC"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0002 110.542C78.5281 110.542 77.333 109.35 77.333 107.875V51.8752C77.333 50.4006 78.5281 49.208 80.0002 49.208C81.4724 49.208 82.6675 50.4006 82.6675 51.8752V107.875C82.6675 109.35 81.4724 110.542 80.0002 110.542Z",
  fill: "#3F95BC"
});

function SvgNumberSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberSystem);
export default __webpack_public_path__ + "static/media/number-system.709eb8d9.svg";
export { ForwardRef as ReactComponent };